import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './custom.scss';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { initializeFirebase } from './push-notification';
import firebase from 'firebase';

// We listen to the resize event
window.addEventListener('resize', () => {
    // We execute the same script as before
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});
// We execute the same script as before
let vh = window.innerHeight * 0.01;
document.documentElement.style.setProperty('--vh', `${vh}px`);

ReactDOM.render(<App />, document.getElementById('root'));

initializeFirebase();

const messaging = firebase.messaging();

messaging.onTokenRefresh(function() {
    messaging.getToken().then(function(refreshedToken) {
        console.log('Token refreshed: '+refreshedToken);
    }).catch(function(err) {
        console.error('Unable to retrieve refreshed token: '+err);
    });
});

navigator.serviceWorker
  .register('/firebase-messaging-sw.js')
  .then((registration) => {
      console.log('SW registered:', registration.scope);
  });

window.setNativePushToken = function(token) {
    console.log("Get a new token FCM:", token);
    localStorage.setItem("token", token);
};
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
